<script>
  import { getContext } from "svelte";
  import Image from "$lib/components/Image.svelte";
  import { altTextToDisplay } from "$lib/utilities";

  export let containerClass = "";
  export let elementClass = "rounded-5";
  export let data;

  export let displayCaption = true;
  export let resizeParams = {};
  export let dimensions = {};

  // Deprecated in favor of eagerload
  export let preload = false;

  //Ordinarily we just use the context, but we need to override this
  //in some cases like featured images on our templates
  export let containerized = getContext("containerized");

  // Image sizes (widths) for available breakpoints.
  // These can be set using any unit, but we recommend using vw (50vw, 100vw, etc.)
  // If you don't set these, the image will be full width at all breakpoints.
  export let lg = "75vw";
  export let md;
  export let sm;

  // Pass through following a more conventional naming convention
  export let eagerload = preload;
  // Responsive flag
  export let responsive = true;

  export let widthClass = "";
  // These don't do much other than provide the browser with
  // the correct aspect ratio for the image. But we allow
  // the user to override them if they want (e.g., if we do
  // some cropping via our image service)
  $: imageDimensions = {
    width: data.fields.imageAsset?.fields?.file?.details?.image?.width,
    height: data.fields.imageAsset?.fields?.file?.details?.image?.height,
    ...dimensions
  };

  $: widthClass = imageDimensions.width < 806 && !containerized ? " md:max-w-806 mx-auto" : "";

  export let altText = altTextToDisplay(data.fields.altText);
  altText = !data.fields?.imageIsDecorative ? altText : "";
</script>

<div class:embedded-content={!containerized} class:containerized-image={containerized}>
  <Image
    id={data.sys?.id}
    containerClass={`${containerClass} ${widthClass}`}
    {elementClass}
    asset={data.fields.imageAsset}
    alt={altText}
    caption={displayCaption ? data.fields.caption : null}
    {eagerload}
    {resizeParams}
    dimensions={imageDimensions}
    {responsive}
    widthsAt={{ lg, md, sm }}
  />
</div>
